'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withCurrentArticle = require('./with-current-article');

Object.defineProperty(exports, 'withCurrentArticle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withCurrentArticle).default;
  }
});

var _CurrentArticle = require('./CurrentArticle');

Object.defineProperty(exports, 'CurrentArticle', {
  enumerable: true,
  get: function get() {
    return _CurrentArticle.CurrentArticle;
  }
});
Object.defineProperty(exports, 'CurrentArticleProvider', {
  enumerable: true,
  get: function get() {
    return _CurrentArticle.CurrentArticleProvider;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-context/lib/cjs/index.js
 ** module id = 266
 ** module chunks = 1
 **/